var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-css-scale",class:[_vm.position,_vm.className]},[_c('img',{style:({imgClass: '100%'}),attrs:{"src":_vm.url}})])}
var staticRenderFns = []

export { render, staticRenderFns }